import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const Container = styled.div`
  padding: 32px;
`

export const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.xxlarge};
  margin-top: 32px;
  text-align: center;
`

export const Header = styled.header`
  display: flex;
  justify-content: center;
  padding: 32px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};

  ${Title} {
    /* 
    This font-size is not in our theme, it's an exception because it refers to 
    the logo 
    */
    font-size: 38px; /* stylelint-disable-line scales/font-size */
    font-weight: 500;
    margin: 0 0 0 12px;
  }
`

export const RecoveryCodesContainer = styled.div`
  width: 448px;

  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 24px;
  text-align: center;

  padding: 24px 60px;
  margin: 40px auto 0;

  border: 1px dashed ${({ theme }) => theme.colors.border.dark.base};
  border-radius: 3px;
  background: ${({ theme }) => theme.colors.background.secondary[2]};
`
